import React, { useState } from 'react';
import { Leaf } from 'lucide-react';

function Logo({ size = 48, rounded = true, className = '' }) {
  const [imgError, setImgError] = useState(false);
  const logoUrl = process.env.PUBLIC_URL + '/logo.png';

  const wrapperStyle = {
    width: `${size}px`,
    height: `${size}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    display: 'block',
  };

  return (
    <div className={`${rounded ? 'rounded-full bg-green-100' : ''} ${className}`.trim()} style={wrapperStyle}>
      {!imgError ? (
        <img
          src={logoUrl}
          alt="সবর গার্ডেন"
          onError={() => setImgError(true)}
          style={imageStyle}
        />
      ) : (
        <Leaf className="text-green-600" style={{ width: Math.round(size * 0.6), height: Math.round(size * 0.6) }} />
      )}
    </div>
  );
}

export default Logo;
